<template>
    <div>
        <breadcrumb :routerList="[{to:'/chanp/salesTable',title:'销售样表'},{title:'销量样表编辑页面'}]"/>
        <div class="h-content">
            <div class="h-row h-mrt0">
                <div class="h-rowIn">
                    <div class="h-rowBox">
                        <el-form :model="f" label-position="right" ref="f" :inline="true" :rules="rules"
                              class="demo-ruleForm h-formbLine h-formbLine1">
                            <div class="h-rowCon">
                                <div class="h-pieceIn2">
                                    <div class="h-pieceTitle2" style="margin-bottom: 0.3rem;">
                                        <h1>销售样表信息</h1>
                                    </div>
                                    <div class="h-pieceCon2">
                                        <div class="h-formLine Bianjiyb">
                                            <el-form-item label="产品编码" class="h-elformWrap-2">
                                                <el-input v-model="f.prodcode" readonly></el-input>
                                            </el-form-item>
                                            <el-form-item label="产品型号" class="h-elformWrap-2">
                                                <el-input v-model="f.promodel" readonly></el-input>
                                            </el-form-item>
                                            <el-form-item label="产品大类" class="h-elformWrap-2">
                                                <el-input placeholder="输入产品编码自动带出" v-model="f.prodseries" readonly></el-input>

                                                <!--<el-select v-model="f.prodseries" :v="f.prodseries" readonly placeholder="请选择">
                                                    <el-option v-for="(item,index) in LevelName"
                                                               :key="index+1"
                                                               :label="item.levelname"
                                                               :value="item.id">
                                                    </el-option>
                                                </el-select>-->
                                            </el-form-item>

                                            <el-form-item label="型号经理" class="h-elformWrap-2">
                                                <el-input :v="f.userCode" placeholder="请输入" v-model="f.userCode"></el-input>
                                            </el-form-item>
                                       <!--     <el-form-item label="状态" class="h-elformWrap-2">
                                                <brselect category="prodstatus" :v="f.prodstatus" v-model="f.prodstatus"/>
                                            </el-form-item>-->
                                            <el-form-item label="型号属性" class="h-elformWrap-2">
                                                <el-input v-model="f.protype" readonly></el-input>
                                            </el-form-item>
                                            <el-form-item label="二类是否覆盖6858" class="h-elformWrap-2">
                                                <brselect category="permit" :v="f.have6858" v-model="f.have6858"/>
                                            </el-form-item>
                                            <el-form-item label="二类是否覆盖6840" class="h-elformWrap-2">
                                                <brselect category="permit" :v="f.have6840" v-model="f.have6840"/>
                                            </el-form-item>
                                            <el-form-item label="三类是否覆盖6854" class="h-elformWrap-2">
                                                <brselect category="permit" :v="f.have6854" v-model="f.have6854"/>
                                            </el-form-item>
                                            <el-form-item label="三类是否覆盖6840" class="h-elformWrap-2" prop="three6840">
                                                <brselect category="permit" :v="f.three6840" v-model="f.three6840"/>
                                            </el-form-item>
                                            <el-form-item label="公司名称" class="h-elformWrap-2">
                                                <brselect category="xsyb_gongsi" :v="f.companycode"
                                                          v-model="f.companycode"/>
                                            </el-form-item>
                                            <el-form-item label="产地" class="h-elformWrap-2">
                                                <el-select v-model="f.factory" placeholder="请选择" disabled>
                                                    <el-option value="9393">9393</el-option>
                                                    <el-option value="9370">9370</el-option>
                                                </el-select>
                                            </el-form-item>
                                            <el-form-item label="类别" class="h-elformWrap-2">
                                                <el-select v-model="f.sort" placeholder="请选择" :clearable="true">
                                                    <el-option value="三高">三高</el-option>
                                                    <el-option value="三生">三生</el-option>
                                                </el-select>
                                            </el-form-item>
                                            <el-form-item label="有效期" class="h-elformWrap-2">
                                                <el-date-picker placeholder="请输入"
																   v-model="f.validperiod"
                                                   value-format="yyyy-MM-dd"
																	:clearable="false"></el-date-picker>
                                            </el-form-item>
                                            <el-form-item label="是否计入销额" class="h-elformWrap-2">
                                                <brselect  category="xiaoe_jishu" :v="f.xiaoe" v-model="f.xiaoe" disabled></brselect>
                                            </el-form-item>
                                            <el-form-item label="是否计入基数" class="h-elformWrap-2">
                                                <brselect category="xiaoe_jishu" :v="f.jishu" v-model="f.jishu" disabled></brselect>
                                            </el-form-item>
                                            <el-form-item label="链群" class="h-elformWrap-2">
                                                <brselectlazy category="xsyb_lianqun" v-model="f.lianqun"
                                                              :v="f.lianqun"></brselectlazy>
                                            </el-form-item>
                                            <el-form-item label="子链群" class="h-elformWrap-2" prop="lianqunchild">
                                                <brselectlazy category="xsyb_lianqunchild" v-model="f.lianqunchild"
                                                              :v="f.lianqunchild" :clearable="true"></brselectlazy>
                                            </el-form-item>

                                            <el-form-item label="是否服务产品" class="h-elformWrap-2" prop="isFw">
                                                <el-select v-model="f.isFw" :v="f.isFw" placeholder="请选择">
                                                    <el-option v-for="(item) in fwList"
                                                               :key="item.code"
                                                               :label="item.name"
                                                               :value="item.code">
                                                    </el-option>
                                                </el-select>
                                            </el-form-item>
                                            <!-- <el-form-item label="子链群" class="h-elformWrap-2">
                                                <el-input v-model="f.lianqunchild" readonly></el-input>
                                            </el-form-item> -->

                                            <el-form-item label="渠道专供" class="h-elformWrap-3">
                                                <brselectlazy :multiple="true" category="sales_region" :v="f.channel" v-model="f.channel" />
                                            </el-form-item>

                                            <el-form-item label="区域" class="h-elformWrap-3"   prop="areacodelist">

                                                <el-checkbox  @change="selectAll">全选</el-checkbox>
                                                <div style="margin: 15px 0;"></div>
                                                <el-checkbox-group v-model="f.areacodelist" >
                                                    <el-checkbox v-for="item in options" :label="item.value" :key="item.value" >{{item.label}}</el-checkbox>
                                                </el-checkbox-group>

                                            </el-form-item>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </el-form>
                    </div>
                </div>
            </div>
            <div class="h-txtCenter h-mrt60">
                <el-button class="h-btn h-bBtn h-bgwhite" @click="backS">返回</el-button>
                <el-button class="h-btn h-bBtn h-bgblueQ2" @click="updatelist">确认提交</el-button>
            </div>
        </div>
    </div>
</template>

<script>
	import ss from '../../api/SystemService'
 	export default {
		data() {
			return {
                f:{
                    areacodelist: [],
                },
                LevelName: [],
                rules: {
                    prodseries: [{required: true, message: '请选择产品大类', trigger: 'change'}],
                    lianqun: [{required: true, message: '请选择链群', trigger: 'change'}],
                    areacodelist: [{required: true, message: '请选择区域', trigger: 'change'}],

                },
                options: [],
                fwList:[
                    {code:1,name:"是"},
                    {code:0,name:"否"}
                ],
			}
		},
		created() {
			this.query();
            this.showLevelName();

            //初始化内销区域
            var area = this.$store.getters.dictlist("YlSalesArea_chanpin");
            const options = []
            for (var i = 0; i < area.length; i++) {
                var opt = {
                    value: area[i].code,
                    label: area[i].name
                };
                //不是9开头表示内销区域
                if(opt.value.substring(0, 1) != "9"){
                    options.push(opt)
                }

            }
            this.options = options

		},
		methods: {
            //产品大类
            showLevelName() {
                ss.UserDemand.showLevelName().then(rd => {
                    this.LevelName = rd;
                })
            },
			query() {
				this.f.id = this.$route.query.id;
				ss.salesList.selectById(this.f.id).then(rd => {
				    this.f = rd;
					this.$set(this.f,'areacodelist', []);
                    this.f.areacodelist = this.f.areacode? this.f.areacode.split(","): [];
					this.f.companyname = this.$getDictName("xsyb_gongsi",this.f.companycode);
                    this.f.lianqunname = this.$getDictName("xsyb_lianqun",this.f.lianqun);
				})
			},
			backS() {
				this.$router.push({path: "/chanp/salesTable"});
			},
			updatelist() {
                var subflag = false;
                this.$refs['f'].validate((valid) => {
                    if (valid) {
                        subflag = true;
                    } else {
                        this.$msg.msge("请完善信息后再提交！");
                        return false;
                    }
                });
                if (subflag == true) {
                    for (var i = 0; i < this.LevelName.length; i++) {
                        if (this.LevelName[i].id == this.f.prodseries) {
                            this.f.oneLid = this.LevelName[i].id;
                            this.f.prodseries = this.LevelName[i].levelname;
                        }
                    }
                    this.f.areacode = this.f.areacodelist.join(",");
                    ss.salesList.reSubmit(this.f).then(rd => {
                        this.$msg.msgs("操作成功");
                        this.$router.push({path: "/chanp/salesTable"});
                    })
                }
			},
            selectAll(v) {
                if(v){
                    this.f.areacodelist = []
                    for (var i = 0; i < this.options.length; i++) {
                        this.f.areacodelist.push(this.options[i].value);
                    }
                 }else{
                    this.f.areacodelist = []
                }
            },
		}
	}
</script>

<style>
	.Bianjiyb .el-form-item__label {
		width: 42%;
		text-align: right;
	}

	.Bianjiyb .el-form-item__content {
		width: 58%;
	}

	.Bianjiyb .h-elformWrap-2 {
		width: 33.333% !important;
		padding-right: 0.5rem
	}
	.Bianjiyb .h-elformWrap-3 {
		width: 100%;
		padding-right: 0.5rem
	}
	.Bianjiyb .h-elformWrap-3 .el-form-item__label {
		width: 13%;
	}
	.Bianjiyb .h-elformWrap-3 .el-form-item__content {
		width: 87%;
	}
</style>
